import { useState, createContext, useContext } from "react";
import vinyl from "../images/vinyl.webp";

const SrcErrorContext = createContext();

export default function ContextWrapper({ children }) {
  const [srcError, setSrcError] = useState("");
  const [imageError, setImageError] = useState(vinyl);

  return (
    <SrcErrorContext.Provider
      value={{
        srcError,
        setSrcError,
        imageError,
        setImageError,
      }}
    >
      {children}
    </SrcErrorContext.Provider>
  );
}

export const useSrcErrorContext = () => {
  return useContext(SrcErrorContext);
};
